/* Kingsway — Workshop theme behaviour */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    // Mobile menu
    document.querySelectorAll('[data-ws-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var header = btn.closest('[data-ws-header]');
        var open = header.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Parts lookup (work order): combine make + model + part into one search
    document.querySelectorAll('[data-ws-lookup]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var parts = [];
        form.querySelectorAll('[data-ws-q]').forEach(function (el) {
          var v = (el.value || '').trim();
          if (v && v.indexOf('__') !== 0) parts.push(v);
        });
        var q = parts.join(' ');
        var url = form.getAttribute('action') + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q);
        window.location.href = url;
      });
    });

    // Quantity steppers
    document.querySelectorAll('[data-ws-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v = Math.max(1, v + parseInt(b.getAttribute('data-step'), 10));
          input.value = v;
        });
      });
    });

    // Product gallery
    document.querySelectorAll('[data-ws-gallery]').forEach(function (g) {
      var main = g.querySelector('.ws-gallery__img');
      g.querySelectorAll('[data-ws-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          if (!main) return;
          main.src = t.getAttribute('data-src');
          main.srcset = '';
          main.alt = t.getAttribute('data-alt') || '';
          g.querySelectorAll('[data-ws-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
          t.setAttribute('aria-current', 'true');
        });
      });
    });

    // Variant select -> hidden id + price/stock
    document.querySelectorAll('[data-ws-variant-select]').forEach(function (sel) {
      var form = sel.closest('form');
      var dataEl = document.getElementById(sel.getAttribute('data-ws-variant-select'));
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      sel.addEventListener('change', function () {
        var v = variants.find(function (x) { return String(x.id) === sel.value; });
        if (!v) return;
        var price = document.querySelector('[data-ws-price]');
        if (price) price.textContent = v.price_formatted;
        var sku = document.querySelector('[data-ws-sku]');
        if (sku) sku.textContent = v.sku || '';
        var btn = form.querySelector('[type=submit]');
        if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.getAttribute('data-label') : 'SOLD OUT'; }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      });
    });

    // Product recommendations ("parts that fit")
    // Try complementary products first (set in Search & Discovery), fall back to related.
    document.querySelectorAll('[data-ws-recs][data-url]').forEach(function (el) {
      var base = el.getAttribute('data-url');
      function load(intent) {
        return fetch(base + '&intent=' + intent).then(function (r) { return r.text(); }).then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var inner = tmp.querySelector('[data-ws-recs]');
          if (inner && inner.innerHTML.trim().length) { el.innerHTML = inner.innerHTML; el.hidden = false; return true; }
          return false;
        });
      }
      load('complementary').then(function (ok) { if (!ok) return load('related'); }).catch(function () {});
    });

    // Collection: auto-submit facets and sort
    document.querySelectorAll('[data-ws-facets]').forEach(function (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type=checkbox], select')) form.submit();
      });
    });
  });
})();
